import React, { useState, useEffect } from "react"
import {
  SearchFiltersContainer,
  TriggerItem,
  Label,
  FilterCount,
  ResultsCount,
  Filters,
} from "./style"
import { ReactComponent as Arrow } from "images/icons/arrow-right.svg"
import Filter from "./Filter"
import { useStaticQuery, graphql } from "gatsby"

const SearchFilters = ({
  filters,
  setFilters,
  facets,
  totalPosts,
  noQuery,
}) => {
  const data = useStaticQuery(
    graphql`
      query GET_COUNT {
        wpgraphql {
          getPageCount {
            business
            live
            study
            work
          }
        }
      }
    `
  )

  const count = data.wpgraphql.getPageCount
  const [filtersShown, setFiltersShown] = useState()

  return (
    <SearchFiltersContainer>
      <TriggerItem
        filtersShown={filtersShown}
        onClick={() => setFiltersShown(!filtersShown)}
      >
        <Label>
          <h4>Filters</h4>{" "}
          {filters.length > 0 && <FilterCount>{filters.length}</FilterCount>}
        </Label>
        {!noQuery ? (
          <ResultsCount>
            <span>{totalPosts > 0 ? totalPosts : 0}</span>results found.
          </ResultsCount>
        ) : null}
        <Arrow />
      </TriggerItem>

      <Filters filtersShown={filtersShown}>
        <Filter
          setFilters={setFilters}
          filters={filters}
          label="Study"
          site="study"
          // count={facets && facets.site ? facets.site.study : count.study}
          count={facets && facets.site && facets.site.study}
        />
        <Filter
          setFilters={setFilters}
          filters={filters}
          label="Work"
          site="work"
          // count={facets && facets.site ? facets.site.work : count.work}
          count={facets && facets.site && facets.site.work}
        />
        <Filter
          setFilters={setFilters}
          filters={filters}
          label="Do Business"
          site="business"
          // count={facets && facets.site ? facets.site.business : count.business}
          count={facets && facets.site && facets.site.business}
        />
        <Filter
          setFilters={setFilters}
          filters={filters}
          label="Live"
          site="live"
          // count={facets && facets.site ? facets.site.live : count.live}
          count={facets && facets.site && facets.site.live}
        />
        {/* Uncoment this bit to add the Visit filter to the search page, may have to re-style the container tho. */}
        {/* <Filter
          setFilters={setFilters}
          filters={filters}
          label="Visit"
          site="visit"
          // count={facets && facets.site ? facets.site.live : count.live}
          count={facets && facets.site && facets.site.visit}
        /> */}
      </Filters>
    </SearchFiltersContainer>
  )
}

export default SearchFilters
